import { Navigate, useSearchParams } from 'react-router-dom'
import { useAppStore } from '@/store/useAppStore'
import { useAuthFlowStore } from '@features/web-auth'
import { ROUTES } from '@shared/config/routes'
import type { ReactNode } from 'react'

interface Props { children: ReactNode }

/**
 * Если юзер уже авторизован — редирект в приложение (или по ?redirect=).
 *
 * Исключение: пока флоу веб-авторизации на блокирующем шаге
 * (code/offer-telegram/name), редирект подавляется. Иначе поллинг привязки
 * Telegram (useTelegramLinkPolling → setProfile) выставляет isAuthenticated
 * и выкидывает юзера со страницы привязки до подтверждения. По завершении
 * флоу вызывается reset() (step→'email') и редирект отрабатывает штатно.
 */
export const PublicRoute = ({ children }: Props) => {
  const isAuthenticated = useAppStore((s) => s.isAuthenticated)
  const flowStep = useAuthFlowStore((s) => s.step)
  const [params] = useSearchParams()

  const flowInProgress =
    flowStep === 'code' || flowStep === 'offer-telegram' || flowStep === 'name'

  if (isAuthenticated && !flowInProgress) {
    const redirect = params.get('redirect') || ROUTES.HOME
    return <Navigate to={redirect} replace />
  }
  return <>{children}</>
}
